import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ARTIFACTS_FILTER_OPTION, DATE_RANGE_TYPE } from '../../constants';

type ConferenceHistoryState = {
    from: string | null;
    to: string | null;
    artifacts: ARTIFACTS_FILTER_OPTION;
    dateRangeType: DATE_RANGE_TYPE;
    selectedMonth: Date | null;
};

const initialState: ConferenceHistoryState = {
    from: null,
    to: null,
    artifacts: ARTIFACTS_FILTER_OPTION.ALL_CONFS,
    dateRangeType: DATE_RANGE_TYPE.FOR_3_MONTH,
    selectedMonth: null,
};

const conferencesHistoryFilterSlice = createSlice({
    name: 'conferencesHistoryFilter',
    initialState,
    reducers: {
        setFilterFromTo(
            state: ConferenceHistoryState,
            { payload }: PayloadAction<{ from?: string | null; to?: string | null }>
        ) {
            if (payload.from !== undefined) {
                state.from = payload.from;
            }
            if (payload.to !== undefined) {
                state.to = payload.to;
            }
        },
        setFilterArtifacts(state: ConferenceHistoryState, { payload }: PayloadAction<ARTIFACTS_FILTER_OPTION>) {
            state.artifacts = payload;
        },
        setFilterDateRangeType(state: ConferenceHistoryState, { payload }: PayloadAction<DATE_RANGE_TYPE>) {
            state.dateRangeType = payload;
        },
        setFilterSelectedMonth(state: ConferenceHistoryState, { payload }: PayloadAction<Date | null>) {
            state.selectedMonth = payload;
        },
        resetAllFilters(state: ConferenceHistoryState) {
            state.from = null;
            state.to = null;
            state.artifacts = ARTIFACTS_FILTER_OPTION.ALL_CONFS;
            state.dateRangeType = DATE_RANGE_TYPE.FOR_3_MONTH;
            state.selectedMonth = null;
        },
    },
});

export const { setFilterFromTo, setFilterArtifacts, setFilterDateRangeType, setFilterSelectedMonth, resetAllFilters } =
    conferencesHistoryFilterSlice.actions;
export const conferencesHistoryFilterReducer = conferencesHistoryFilterSlice.reducer;
